import { getDaysInMonth as getDaysInMonthOfDate } from 'date-fns'

import { DATE_LOTTERY_FIELD_NAME } from '../constants/dateLottery'
import { pickRandomEntry } from './editorPlay'

export type DatePart = 'day' | 'month' | 'year'

export type DateRange = { max: number; min: number }

export type DateRanges = Record<DatePart, DateRange>

export type DateSelection = Record<DatePart, Maybe<number>>

const CENTURY = 2000

const YEAR_DIGITS = 2

export const formatDatePartValue = (name: string, value: number): string =>
  name === DATE_LOTTERY_FIELD_NAME.Year ? String(value).padStart(YEAR_DIGITS, '0') : String(value)

const toValues = ({ max, min }: DateRange) =>
  Array.from({ length: Math.max(0, max - min + 1) }, (_, index) => min + index)

const toCandidates = (ranges: DateRanges, locked: DateSelection, part: DatePart) => {
  const value = locked[part]
  return value === null || value === undefined ? toValues(ranges[part]) : [value]
}

export const getDaysInMonth = (month: number, year?: Maybe<number>): number =>
  getDaysInMonthOfDate(new Date(CENTURY + (year ?? 0), month - 1))

export const clampDay = (day: number, month: number, year?: Maybe<number>): number =>
  Math.min(day, getDaysInMonth(month, year))

const listValidDates = (ranges: DateRanges, locked: DateSelection): DateSelection[] => {
  const valid: DateSelection[] = []

  for (const month of toCandidates(ranges, locked, 'month')) {
    for (const year of toCandidates(ranges, locked, 'year')) {
      const daysInMonth = getDaysInMonth(month, year)
      for (const day of toCandidates(ranges, locked, 'day')) {
        if (day <= daysInMonth) valid.push({ day, month, year })
      }
    }
  }

  return valid
}

export const pickDateCompletion = (ranges: DateRanges, locked: DateSelection): DateSelection => {
  const valid = listValidDates(ranges, locked)
  if (valid.length) return pickRandomEntry(valid) ?? locked

  return pickRandomEntry(listValidDates(ranges, { ...locked, day: null })) ?? locked
}
